import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  max-width: 1000px;
  height: 70px;
  justify-content: space-around;
  align-items: center;
  padding-left: 20px;
  @media (min-width: 3000px) {
    height: 200px;
  }
`;

export const DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0.3rem 0px 0.3rem;
  @media (min-width: 3000px) {
    padding: 20px 0.5rem 0px 0.5rem;
  }
`;

export const ProDataContainer = styled(DataContainer)`
  gap: -30px;
`;

export const Label = styled.p`
  font-size: ${(props) => props.$labelSize};
  color: white;
  font-weight: 300;
  @media (min-width: 3000px) {
    font-size: ${(props) => props.$4KlabelSize};
  }
`;

export const Value = styled.p`
  font-size: ${(props) => props.$valueSize};
  font-weight: bold;
  color: ${(props) => props.color};
  font-weight: 300;
  @media (min-width: 3000px) {
    font-size: ${(props) => props.$4KvalueSize};
  }
`;

export const Top3DataContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px 0.3rem 0px 0.3rem;
  @media (min-width: 3000px) {
    padding: 20px 0.5rem 0px 0.5rem;
  }
`;

export const Top3Box = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
`;

export const Top3Value = styled.p`
  font-size: ${(props) => props.$valueSize};
  font-weight: bold;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${(props) => props.color};
  &:nth-child(1) {
    color: #ffd700;
  }

  &:nth-child(2) {
    color: #c0c0c0;
  }

  &:nth-child(3) {
    color: #cd7f32;
  }

  @media (min-width: 3000px) {
    font-size: ${(props) => props.$4KvalueSize};
  }
`;

export const IconBox = styled.div`
  padding: 0px 15px;
  opacity: 0.5;
  &:hover {
    opacity: 1;
  }
`;
export const ProductBox = styled.div`
  display: flex;
  margin-bottom: 0px;
  padding-bottom: 0px;
  height: 35px;
`;
